import { Stack, Typography } from "@altimateai/lego";
import { IconChartBar } from "@tabler/icons-react";

interface EmptyChartProps {
  message?: string;
  height?: number;
}

const EmptyChart = ({
  message = "No data available for this range",
  height = 280,
}: EmptyChartProps) => (
  <Stack
    direction="column"
    align="center"
    justify="center"
    gap="sm"
    className="al-w-full al-text-stroke-dark"
    style={{ height }}
  >
    <IconChartBar size={32} className="al-text-stroke-gray-light" aria-hidden="true" />
    <Typography size="sm" className="al-text-stroke-dark">
      {message}
    </Typography>
  </Stack>
);

export default EmptyChart;
